// B2C sign-in settings and API scopes are environment-specific and are loaded at startup
// from GET {apiConfig.uri}config/spa/customer (see main.ts), so one build serves every environment.
export const environment = {
  production: true,
  apiUrl: '/api/',
  confirmUrl: 'https://api.outdooraccess.com/a/',
  malibuUrl: 'https://oa-prod-web.azurewebsites.net/malibu',
  oaWebUrl: 'https://www.outdooraccess.com',
  nextJsUrl: 'https://outdooraccess.com',
  // GA4 Measurement ID (matches the gtag.js snippet in index.html).
  // TODO: eventually source this from the AppSettings table via an API call.
  ga4MeasurementId: 'G-HDDB8V2MY3',
  appInsights: {
    instrumentationKey: '94e50287-523e-4d4f-bf0c-00e0607ae2e2'
  },
  apiConfig: {
    uri: '/api/',
  },
  inboundSmsNumber: "+18044093447"
};
